'use strict';

module.exports = ['$scope', '$mdDialog', '$http',
    function ($scope, $mdDialog, $http) {
        $scope.loading = false;
        $scope.success = false;

        $scope.cancelButton = () => {
            if ($scope.success) {
                $mdDialog.hide();
            } else {
                $mdDialog.cancel();
            }
        };

        $scope.dataIsInvalid = () => {
            if($scope.loading || $scope.success) return true;

            if (!$scope.title) return true;

            return ($scope.title.length < 1);
        };

        $scope.send = () => {
            $scope.loading = true;

            let url = window.location.href;

            $http.post('/send-support', {title: $scope.title, message: $scope.message, url: url})
                .then((response) => {
                    if (response.data == 'ok') {
                        $scope.success = true;
                        setTimeout(() => {
                            $mdDialog.hide();
                        }, 2000)
                    } else {
                        $scope.loading = false;
                    }
                })
        };
    }
];

